if (!customElements.get('product-info')) {
    customElements.define(
        'product-info',
        class ProductInfo extends HTMLElement {
            constructor() {
                super();
                this.input = this.querySelector('.quantity__input');
                this.currentVariant = this.querySelector('.product-variant-id');
                this.submitButton = this.querySelector('[type="submit"]');
                this.sortInventoryStoreList();
            }

            cartUpdateUnsubscriber = undefined;
            variantChangeUnsubscriber = undefined;

            sortInventoryStoreList() {
                // Handle lists within ProductInfo
                const inventoryStoreLists = this.querySelectorAll(
                    '.store-pickup_state-inventory-list'
                );
                if (inventoryStoreLists.length > 0) {
                    this.sortLists(inventoryStoreLists, '.store-pickup_state-inventory-item');
                }

                // Handle lists outside ProductInfo
                const inventoryModalStoreLists =
                    document.querySelectorAll('.store-pickup_list-list');
                if (inventoryModalStoreLists.length > 0) {
                    this.sortLists(inventoryModalStoreLists, '.store-pickup_state-inventory-item');
                }
            }

            sortLists(lists, itemSelector) {
                lists.forEach((list) => {
                    const items = Array.from(list.querySelectorAll(itemSelector)).filter(
                        (item) => item.getAttribute('data-state') !== 'no-avail'
                    );
                    if (items.length === 0) return; // Skip if no items found

                    items.sort((a, b) => {
                        const nameA = a.getAttribute('data-name') || '';
                        const nameB = b.getAttribute('data-name') || '';
                        return nameA.localeCompare(nameB);
                    });
                    items.forEach((item, index) => {
                        item.style.order = index + 1;
                    });

                    // Set order for 'no-avail' items to appear at the end
                    const noAvailItems = list.querySelectorAll(
                        `${itemSelector}[data-state="no-avail"]`
                    );
                    noAvailItems.forEach((item, index) => {
                        item.style.order = items.length + index + 1;
                    });
                });
            }

            connectedCallback() {
                if (!this.input) return;
                this.quantityForm = this.querySelector('.product-form__quantity');
                if (!this.quantityForm) return;
                this.setQuantityBoundries();
                if (!this.dataset.originalSection) {
                    this.cartUpdateUnsubscriber = subscribe(
                        PUB_SUB_EVENTS.cartUpdate,
                        this.fetchQuantityRules.bind(this)
                    );
                }
                this.variantChangeUnsubscriber = subscribe(
                    PUB_SUB_EVENTS.variantChange,
                    (event) => {
                        const sectionId = this.dataset.originalSection
                            ? this.dataset.originalSection
                            : this.dataset.section;
                        if (event.data.sectionId !== sectionId) return;
                        this.updateQuantityRules(event.data.sectionId, event.data.html);
                        this.setQuantityBoundries();
                    }
                );
            }

            disconnectedCallback() {
                if (this.cartUpdateUnsubscriber) {
                    this.cartUpdateUnsubscriber();
                }
                if (this.variantChangeUnsubscriber) {
                    this.variantChangeUnsubscriber();
                }
            }

            setQuantityBoundries() {
                const data = {
                    cartQuantity: this.input.dataset.cartQuantity
                        ? parseInt(this.input.dataset.cartQuantity)
                        : 0,
                    min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
                    max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
                    step: this.input.step ? parseInt(this.input.step) : 1
                };

                let min = data.min;
                const max = data.max === null ? data.max : data.max - data.cartQuantity;
                if (max !== null) min = Math.min(min, max);
                if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

                this.input.min = min;
                this.input.max = max;
                this.input.value = min;
                publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
            }

            fetchQuantityRules() {
                if (!this.currentVariant || !this.currentVariant.value) return;
                this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove(
                    'hidden'
                );
                fetch(
                    `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
                )
                    .then((response) => {
                        return response.text();
                    })
                    .then((responseText) => {
                        const html = new DOMParser().parseFromString(responseText, 'text/html');
                        this.updateQuantityRules(this.dataset.section, html);
                        this.setQuantityBoundries();
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.querySelector('.quantity__rules-cart .loading__spinner').classList.add(
                            'hidden'
                        );
                    });
            }

            updateQuantityRules(sectionId, html) {
                const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
                const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
                for (let selector of selectors) {
                    const current = this.quantityForm.querySelector(selector);
                    const updated = quantityFormUpdated.querySelector(selector);
                    if (!current || !updated) continue;
                    if (selector === '.quantity__input') {
                        const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
                        for (let attribute of attributes) {
                            const valueUpdated = updated.getAttribute(attribute);
                            if (valueUpdated !== null)
                                current.setAttribute(attribute, valueUpdated);
                        }
                    } else {
                        current.innerHTML = updated.innerHTML;
                    }
                }
            }
        }
    );
}

if (!customElements.get('promo-countdown')) {
    customElements.define(
        'promo-countdown',
        class PromoCountdown extends HTMLElement {
            constructor() {
                super();
                this.date = this.dataset.date; // example value: 9-15-24
                this.target = this.querySelector('span');
            }

            connectedCallback() {
                if (this.date.split('-').length !== 3) {
                    console.error('Invalid date format');
                    return;
                }
                this.countdownToDate(this.date);
            }

            countdownToDate(dateString) {
                const [month, day, year] = dateString.split('-').map(Number);
                const targetDate = new Date(`20${year}-${month}-${day}`);
                const countdownElement = this.target;

                const updateCountdown = () => {
                    const now = new Date();
                    const timeDifference = targetDate - now;

                    if (timeDifference <= 0) {
                        countdownElement.innerHTML = window.accessibilityStrings.dateHasArrived;
                        clearInterval(interval);
                        return;
                    }

                    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
                    const hours = Math.floor(
                        (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                    );
                    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

                    const formatNumber = (num) => (num < 10 ? `0${num}` : num);

                    countdownElement.innerHTML = `${formatNumber(days)}:${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`;
                };

                const interval = setInterval(updateCountdown, 1000);
                updateCountdown(); // Initial call to display the countdown immediately
            }
        }
    );
}

if (!customElements.get('state-inventory-item')) {
    customElements.define(
        'state-inventory-item',
        class StateInventoryItem extends HTMLElement {
            constructor() {
                super();
                this.yourStoreModal = document.querySelector('your-store-modal');
            }

            updateStoreModal(storeLoc) {
                if (!storeLoc) return;
                if (!this.yourStoreModal) return;
                const yourStoreModal = this.yourStoreModal;
                const state = storeLoc.split(', ')[1].trim(); // Assuming that the format of the storeLoc is City, State. ie. Burnsville, MN
                const wayButton = yourStoreModal.querySelector('[data-way="pickup"]');
                const stateButton = yourStoreModal.querySelector(`[data-state="${state}"]`);
                const storeButton = yourStoreModal.querySelector(
                    `[name="pickup-store"][value="${storeLoc}"]`
                );
                if (!wayButton && !stateButton && !storeButton) return;
                wayButton.click();
                stateButton.click();
                storeButton.click();
                yourStoreModal.handleSaveClick();
            }

            connectedCallback() {
                const radioInput = this.querySelector('input[type="radio"]');
                if (radioInput) {
                    radioInput.addEventListener('change', (event) => {
                        if (event.target.checked) {
                            // Get all state-inventory-item elements
                            const allItems = document.querySelectorAll('state-inventory-item');
                            const checkedLoc = radioInput.value;
                            this.updateStoreModal(checkedLoc);
                            allItems.forEach((item) => {
                                const itemRadio = item.querySelector('input[type="radio"]');
                                if (itemRadio) {
                                    // Remove checked attribute from all radios
                                    itemRadio.removeAttribute('checked');

                                    // Add checked attribute to radios with the same value
                                    if (itemRadio.value == checkedLoc) {
                                        itemRadio.setAttribute('checked', 'checked');
                                    }
                                }
                            });
                        }
                    });
                }
            }
        }
    );
}
